import type { ReactNode } from "react";
import type { DatasetStorageBackend } from "@/api/datasetStorageBackend";
import { HatTextTooltip } from "@/components/tooltip";
import { storageBackendLabel, storageBackendRestrictionText } from "./storageBackendText";
import styles from "./DatasetStorageBadge.module.css";

/**
 * 기능 제약이 있는 저장 위치의 칩. 모든 기능을 지원하는 위치(GCS)는 null 이다.
 *
 * 칩은 "이 Dataset 은 다르다"는 표시다. 대부분의 Dataset 은 제약이 없어서 표시가 없다. 툴팁이
 * 지원하지 않는 기능을 알린다. 카드, 표의 이름 칸, 상세 제목이 함께 쓴다.
 *
 * 컴포넌트가 아니라 함수다. 칩이 없을 때 호출부가 슬롯에 `null` 을 넣어야 빈 래퍼와 gap 이
 * 생기지 않는다(`datasetDetailTitleBadge` 와 같은 계약).
 */
export function datasetStorageBadge(backend: DatasetStorageBackend): ReactNode {
  const restriction = storageBackendRestrictionText(backend);
  if (restriction === null) {
    return null;
  }
  return (
    <HatTextTooltip text={restriction}>
      <span className={styles.badge}>{storageBackendLabel(backend)}</span>
    </HatTextTooltip>
  );
}
